import { ReactElement } from 'react';

import { createTranslatedText } from '@dreryk/react-common';
import { SecondaryText, StrongText } from '@dreryk/react-components';

type FacilityDescriptionProps = {
   readonly name: string;
   readonly address: string | null;
};

export const FacilityDescription = (props: FacilityDescriptionProps): ReactElement => {
   return (
      <>
         <StrongText testId={'facilityName'}>{props.name}</StrongText>
         {Boolean(props.address) && (
            <SecondaryText testId={'facilityAddress'} text={createTranslatedText(props.address)} compact />
         )}
      </>
   );
};
